import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { Divider } from '@mui/material'
import { colors } from 'src/theme'
import { ContractorStepDetailsCardUsageVariant } from '../constants'
import { ContractorStepDetailsBaseContentBlock } from './ContractorStepDetailsBaseContentBlock'
import { SubmissionBlock } from '../types'

export interface ContractorStepDetailsCardContentProps {
  usageVariant: ContractorStepDetailsCardUsageVariant
  contentBlocks: SubmissionBlock[]
  readOnly?: boolean
}

const ContractorStepDetailsCardContentComponent = ({
  usageVariant,
  contentBlocks,
  readOnly = false,
}: ContractorStepDetailsCardContentProps) => {
  const blocks = contentBlocks

  if (!blocks.length) {
    return null
  }

  return (
    <div
      css={[
        tw`flex flex-col rounded-lg min-w-0 w-full overflow-hidden mt-4 border border-solid`,
        { borderColor: colors.SHADES_GREY_100 },
      ]}
    >
      {blocks.map((block, index) => (
        <Fragment key={`${block.status}-${block.expiresAt}-${index}`}>
          {index > 0 && (
            <Divider css={[tw`mt-0 mb-0 w-full`, { borderColor: colors.SHADES_GREY_100 }]} />
          )}
          <ContractorStepDetailsBaseContentBlock
            block={block}
            usageVariant={usageVariant}
            readOnly={readOnly}
          />
        </Fragment>
      ))}
    </div>
  )
}

export const ContractorStepDetailsCardContent = memo(ContractorStepDetailsCardContentComponent)
